import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function AnyaIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1205 2.88184C6.4747 6.97199 3.81527 12.2326 4.19532 19.2282C9.2676 21.5674 13.7275 21.8585 19.9997 19.409C19.9811 16.0756 19.9997 14.6055 19.14 12.6516L17.186 13.5787C17.7845 15.3097 17.7413 15.3196 17.8719 17.9507C13.5091 19.3981 10.1994 19.4078 6.25632 17.8372C6.2636 11.347 9.35981 7.46457 13.8097 4.18941C13.2519 3.70715 12.7011 3.29707 12.1205 2.88184Z"
        fill="currentColor"
      />
      <path
        d="M13.2784 8.09252C16.535 8.09252 16.535 4.83594 16.535 4.83594C16.535 4.83594 16.535 8.09252 19.7916 8.09252C16.535 8.09252 16.535 11.3491 16.535 11.3491C16.535 11.3491 16.535 8.09252 13.2784 8.09252Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.30263"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
